import { SEO } from "../components/SEO";

export default function ContactSection() {
  return (
    <>
      <SEO 
        title="Contact Ebosetale Okhueleigbe | Get in Touch"
        description="Contact Ebosetale Okhueleigbe for speaking engagements, collaborations, or inquiries. Connect with a leading voice in tax policy, gender equality, and women empowerment."
        canonicalUrl="https://www.ebosetaleokhueleigbe.com/contact"
      />
      <section className="min-h-screen bg-black flex items-center justify-center text-center px-6 py-20">
      <div>
        <h1 className="text-4xl md:text-5xl font-playfair text-yellow-300 mb-4">
          Contact Ebosetale Okhueleigbe
        </h1>
        <p className="text-lg md:text-xl font-outfit text-gray-300">
          This section is currently under development. Please check back soon.
        </p>
      </div>
    </section>
    </>
  );
}